import { apiService } from './api';
import { AssetTypeInfo } from '../types';

class AssetTypesService {
  async list(query?: string): Promise<AssetTypeInfo[]> {
    const params = query ? { query } : undefined;
    return apiService.get<AssetTypeInfo[]>('/asset-types/', params);
  }

  async getByType(typeCode: string): Promise<AssetTypeInfo> {
    return apiService.get<AssetTypeInfo>(`/asset-types/${encodeURIComponent(typeCode)}`);
  }
}

export const assetTypesService = new AssetTypesService();
